import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPen16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPen16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m13.187 4.065-1.65-1.65-1.269 1.267 1.651 1.65zm-9.834 6.532 6.208-6.208 1.651 1.65-6.208 6.209-2.117.466zm2.152 2.565 8.39-8.39a1 1 0 0 0 0-1.414l-1.652-1.65a1 1 0 0 0-1.414 0l-8.39 8.389-.528 2.402a1 1 0 0 0 1.191 1.191zM10 13a.5.5 0 0 0 0 1h3.5a.5.5 0 1 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPen16);
